/* ==========================================================================
   CROWN JULE — theme.js
   No dependencies. Every scroll-linked or pointer-linked effect is gated on
   motionOn(), which respects prefers-reduced-motion, the theme settings, and
   the "simplify on mobile" switch. Phones scroll at native speed.
   ========================================================================== */
(function () {
  'use strict';

  var CJ = window.CJ || {};
  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var mqPhone = window.matchMedia('(max-width: 749px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function isDesktop() { return mqDesktop.matches; }
  function reduced() { return mqReduce.matches || CJ.animations === false; }
  function motionOn() {
    if (reduced()) return false;
    if (mqPhone.matches && CJ.simplifyMobile !== false) return false;
    return true;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function str(key, fallback) { return (CJ.strings && CJ.strings[key]) || fallback; }

  /* ---------------------------------------------------------------- scroll */

  var scrollTasks = [];
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      for (var i = 0; i < scrollTasks.length; i++) {
        try { scrollTasks[i](vh); } catch (e) { /* keep the rest alive */ }
      }
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ------------------------------------------------------------ body lock */

  // iOS ignores overflow:hidden on body, so pin it and restore the offset.
  var scrollLockY = 0;
  var lockCount = 0;
  function lockBody() {
    if (lockCount++ > 0) return;
    scrollLockY = window.scrollY;
    document.body.style.top = -scrollLockY + 'px';
    document.body.classList.add('cj-locked');
  }
  function unlockBody() {
    if (lockCount === 0) return;
    if (--lockCount > 0) return;
    document.body.classList.remove('cj-locked');
    document.body.style.top = '';
    window.scrollTo(0, scrollLockY);
  }

  /* --------------------------------------------------------------- overlay */

  function overlay(show, handler) {
    var el = $('[data-cj-overlay]');
    if (!el) return;
    if (show) {
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      el.onclick = handler;
    } else {
      el.classList.remove('is-open');
      el.onclick = null;
      window.setTimeout(function () {
        if (!el.classList.contains('is-open')) el.hidden = true;
      }, 300);
    }
  }

  /* ---------------------------------------------------------------- header */

  function initHeader() {
    var header = $('[data-cj-header]');
    if (!header) return;
    scrollTasks.push(function () {
      header.classList.toggle('is-stuck', window.scrollY > 24);
    });
  }

  /* ----------------------------------------------------------- mobile menu */

  function initMenu() {
    var menu = $('[data-cj-menu]');
    if (!menu || menu.__bound) return;
    menu.__bound = true;
    var openers = $$('[data-cj-menu-open]');
    var closers = $$('[data-cj-menu-close]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockBody();
      overlay(true, close);
      var first = menu.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      unlockBody();
      overlay(false);
      if (lastFocus) lastFocus.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });

    $$('[data-cj-submenu-toggle]', menu).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        if (!panel) return;
        var isOpen = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    $$('a', menu).forEach(function (a) {
      a.addEventListener('click', function () { close(); });
    });

    mqDesktop.addEventListener('change', function (e) {
      if (e.matches && menu.classList.contains('is-open')) close();
    });
  }

  /* ---------------------------------------------------------------- reveal */

  function columnsOf(grid) {
    var tpl = window.getComputedStyle(grid).gridTemplateColumns;
    if (!tpl || tpl === 'none') return 1;
    return tpl.split(' ').filter(Boolean).length || 1;
  }

  function initReveal(ctx) {
    var root = ctx || document;
    var els = $$('.cj-reveal', root).filter(function (el) { return !el.__revealed; });
    if (!els.length) return;

    if (reduced() || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); el.__revealed = true; });
      return;
    }

    // Grids stagger by column so a row lights up left-to-right, and the
    // whole grid never animates in one block.
    $$('[data-cj-stagger]', root).forEach(function (grid) {
      var cols = columnsOf(grid);
      $$('.cj-reveal', grid).forEach(function (el, i) {
        el.style.transitionDelay = ((i % cols) * 90) + 'ms';
        el.__staggered = true;
      });
    });

    $$('[data-cj-reveal-group]', root).forEach(function (group) {
      $$('.cj-reveal', group).forEach(function (el, i) {
        if (el.__staggered) return;
        el.style.transitionDelay = Math.min(i * 80, 320) + 'ms';
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

    els.forEach(function (el) { el.__revealed = true; io.observe(el); });
  }

  /* --------------------------------------------------- specular light sweep */

  // One shared list and one scroll task. Elements added later (quick view,
  // recommendations) join the same list, and the task is re-registered by
  // initAll so it survives a theme-editor section reload.
  var specularEls = [];

  function initSpecular(ctx) {
    if (!motionOn() || CJ.shine === false) return;
    $$('[data-cj-specular]', ctx || document).forEach(function (s) {
      if (s.__sweep) return;
      var sweep = document.createElement('div');
      sweep.className = 'cj-sweep';
      s.appendChild(sweep);
      s.__sweep = sweep;
      specularEls.push(s);
    });
  }

  function specularTask(vh) {
    for (var i = specularEls.length - 1; i >= 0; i--) {
      var s = specularEls[i];
      if (!s.isConnected) { specularEls.splice(i, 1); continue; }
      var r = s.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      s.__sweep.style.backgroundPosition = (120 - p * 240) + '% 0';
    }
  }

  /* ------------------------------------------------------------ hero float */

  function initFloat() {
    if (!motionOn()) return;
    var els = $$('[data-cj-float]');
    if (!els.length) return;
    var travel = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--cj-hero-float')
    ) || 28;
    scrollTasks.push(function (vh) {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var factor = parseFloat(el.getAttribute('data-cj-float')) || 0;
        var p = (vh - r.top) / (vh + r.height) - 0.5;
        el.style.transform = 'translate3d(0,' + (p * travel * factor).toFixed(2) + 'px,0)';
      });
    });
  }

  /* ------------------------------------------------------------------ tilt */

  // A short, shallow rotation toward the cursor. Pointer-fine devices only,
  // and only on cards the merchant explicitly marked as featured.
  function initTilt(ctx) {
    if (!motionOn() || CJ.tilt === false || !mqHover.matches) return;
    $$('[data-cj-tilt]', ctx || document).forEach(function (card) {
      if (card.__tilt) return;
      card.__tilt = true;
      var frame = null;

      function apply(e) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          card.style.transform =
            'perspective(900px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' +
            (x * 5).toFixed(2) + 'deg)';
        });
      }

      card.addEventListener('pointerenter', function () { card.classList.add('is-tilting'); });
      card.addEventListener('pointermove', apply);
      card.addEventListener('pointerleave', function () {
        if (frame) { cancelAnimationFrame(frame); frame = null; }
        card.classList.remove('is-tilting');
        card.style.transform = '';
      });
    });
  }

  /* -------------------------------------------------------------- wishlist */

  var WISH_KEY = 'cj-wishlist';

  function readWish() {
    try { return JSON.parse(window.localStorage.getItem(WISH_KEY)) || []; }
    catch (e) { return []; }
  }
  function writeWish(list) {
    try { window.localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  function paintWish(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var name = btn.getAttribute('data-cj-wish-name') || '';
    btn.setAttribute('aria-label', (on ? str('saved', 'Saved') : str('save', 'Save for later')) + (name ? ': ' + name : ''));
  }

  function initWishlist(ctx) {
    var saved = readWish();
    $$('[data-cj-wish]', ctx || document).forEach(function (btn) {
      var id = btn.getAttribute('data-cj-wish');
      if (!btn.__bound) {
        btn.__bound = true;
        btn.setAttribute('data-cj-wish-name', (btn.getAttribute('aria-label') || '').split(': ').slice(1).join(': '));
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var list = readWish();
          var at = list.indexOf(id);
          if (at === -1) { list.push(id); } else { list.splice(at, 1); }
          writeWish(list);
          // Keep every copy of this product on the page in sync.
          $$('[data-cj-wish="' + id + '"]').forEach(function (b) { paintWish(b, at === -1); });
        });
      }
      paintWish(btn, saved.indexOf(id) !== -1);
    });
  }

  /* ------------------------------------------------------------ quick view */

  function initQuickView() {
    var modal = $('[data-cj-quick-modal]');
    if (!modal || modal.__bound) return;
    modal.__bound = true;
    var body = $('[data-cj-quick-body]', modal);
    var lastFocus = null;
    var loadingHtml = body ? body.innerHTML : '';

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockBody();
      overlay(false);
      window.setTimeout(function () {
        if (!modal.classList.contains('is-open')) {
          modal.hidden = true;
          if (body) body.innerHTML = loadingHtml;
        }
      }, 380);
      if (lastFocus) lastFocus.focus();
    }

    function open(url) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      lockBody();
      overlay(true, close);
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
      });

      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'section_id=quick-view', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('quick view unavailable');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-cj-quick-content]');
          if (!content || !body) throw new Error('quick view empty');
          body.innerHTML = '';
          body.appendChild(content);
          initVariants(body);
          initQuantity(body);
          bindAddForms(body);
          initSpecular(body);
          initRails(body);
          var focusTarget = body.querySelector('button, a, input');
          if (focusTarget) focusTarget.focus();
        })
        .catch(function () {
          // Never strand the shopper in an empty modal — send them to the page.
          close();
          window.location.href = url;
        });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-cj-quick]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      open(trigger.getAttribute('data-cj-quick'));
    });

    $$('[data-cj-quick-close]', modal).forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ------------------------------------------------------------ accordions */

  function initAccordions(ctx) {
    $$('[data-cj-accordion-trigger]', ctx || document).forEach(function (btn) {
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
  }

  /* -------------------------------------------------------- quantity input */

  function initQuantity(ctx) {
    $$('[data-cj-qty]', ctx || document).forEach(function (wrap) {
      if (wrap.__bound) return;
      wrap.__bound = true;
      var input = $('input', wrap);
      if (!input) return;
      $$('button', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-cj-qty-step') === 'up' ? 1 : -1;
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* -------------------------------------------------------- collection tabs */

  function initFilters(ctx) {
    $$('[data-cj-filters]', ctx || document).forEach(function (bar) {
      if (bar.__bound) return;
      bar.__bound = true;
      var scope = bar.closest('[data-cj-filter-scope]') || document;
      var cards = $$('[data-cj-tags]', scope);
      var btns = $$('[data-cj-filter]', bar);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-cj-filter');
          btns.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          cards.forEach(function (c) {
            var tags = (c.getAttribute('data-cj-tags') || '').split(/\s+/);
            var show = val === 'all' || tags.indexOf(val) !== -1;
            c.hidden = !show;
          });
          btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        });
      });
    });
  }

  /* ----------------------------------------------------------- swipe rails */

  // Builds dots for any horizontal rail and keeps them in step with the
  // scroll position. Used by the product carousels and the quick view.
  function initRails(ctx) {
    $$('[data-cj-rail], [data-cj-quick-rail]', ctx || document).forEach(function (rail) {
      if (rail.__rail) return;
      rail.__rail = true;
      var wrap = rail.closest('.cj-rail-wrap') || rail.parentNode;
      var dots = wrap && $('[data-cj-rail-dots]', wrap);
      var items = Array.prototype.slice.call(rail.children);
      if (!dots || items.length < 2) return;

      if (!dots.children.length) {
        items.forEach(function (_, i) {
          var d = document.createElement('span');
          if (i === 0) d.className = 'is-active';
          dots.appendChild(d);
        });
      }
      var ds = Array.prototype.slice.call(dots.children);
      var raf = false;
      rail.addEventListener('scroll', function () {
        if (raf) return;
        raf = true;
        requestAnimationFrame(function () {
          raf = false;
          var i = clamp(Math.round(rail.scrollLeft / (rail.scrollWidth / items.length)), 0, ds.length - 1);
          ds.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        });
      }, { passive: true });
    });
  }

  /* ------------------------------------------------ card: tap to see worn */

  // Touch has no hover, so the worn-on image needs a control of its own —
  // tapping the image itself has to stay a navigation.
  function initWorn(ctx) {
    $$('[data-cj-worn]', ctx || document).forEach(function (btn) {
      if (btn.__bound) return;
      btn.__bound = true;
      var media = btn.closest('.cj-card__media');
      var label = $('span', btn);
      if (!media) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var on = media.classList.toggle('is-alt');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (label) label.textContent = on ? str('seeProduct', 'See the piece') : str('seeWorn', 'See it worn');
      });
    });
  }

  /* ------------------------------------------------- fullscreen lightbox */

  var lightboxTotal = 0;

  function openLightbox(slides, index) {
    var box = $('[data-cj-lightbox]');
    var rail = box && $('[data-cj-lightbox-rail]', box);
    if (!box || !rail) return;
    var count = $('[data-cj-lightbox-count]', box);

    rail.innerHTML = '';
    slides.forEach(function (slide) {
      var src = slide.getAttribute('data-cj-full');
      var inner = $('img', slide);
      if (!src && inner) src = inner.currentSrc || inner.src;
      if (!src) return;
      var cell = document.createElement('div');
      cell.className = 'cj-lightbox__slide';
      var img = document.createElement('img');
      img.src = src;
      img.alt = slide.getAttribute('data-cj-alt') || '';
      img.decoding = 'async';
      cell.appendChild(img);
      rail.appendChild(cell);
    });

    lightboxTotal = rail.children.length;
    if (!lightboxTotal) return;
    if (count) count.textContent = (index + 1) + ' / ' + lightboxTotal;

    box.setAttribute('aria-hidden', 'false');
    lockBody();
    requestAnimationFrame(function () {
      box.classList.add('is-open');
      var target = rail.children[index];
      if (target) rail.scrollLeft = target.offsetLeft - rail.offsetLeft;
      var close = $('[data-cj-lightbox-close]', box);
      if (close) close.focus();
    });
  }

  function closeLightbox() {
    var box = $('[data-cj-lightbox]');
    if (!box || !box.classList.contains('is-open')) return;
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden', 'true');
    unlockBody();
  }

  function initLightbox() {
    var box = $('[data-cj-lightbox]');
    if (!box || box.__bound) return;
    box.__bound = true;
    var rail = $('[data-cj-lightbox-rail]', box);
    var count = $('[data-cj-lightbox-count]', box);

    $$('[data-cj-lightbox-close]', box).forEach(function (b) {
      b.addEventListener('click', closeLightbox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });

    if (rail) {
      var raf = false;
      rail.addEventListener('scroll', function () {
        if (raf || !lightboxTotal) return;
        raf = true;
        requestAnimationFrame(function () {
          raf = false;
          var i = clamp(Math.round(rail.scrollLeft / (rail.scrollWidth / lightboxTotal)), 0, lightboxTotal - 1);
          if (count) count.textContent = (i + 1) + ' / ' + lightboxTotal;
        });
      }, { passive: true });
    }
  }

  /* --------------------------------------------------------- product media */

  // One snap rail drives everything: phones swipe it, thumbnails and dots
  // scroll it, and on touch a tap opens the fullscreen viewer.
  function initProductGallery() {
    var gallery = $('[data-cj-gallery]');
    if (!gallery || gallery.__bound) return;
    gallery.__bound = true;
    var stage = $('[data-cj-stage]', gallery);
    if (!stage) return;
    var slides = $$('[data-cj-slide]', stage);
    var dots = $$('[data-cj-dot]', gallery);
    var thumbs = $$('[data-cj-gallery-thumb]', gallery);
    if (!slides.length) return;

    function goTo(i) {
      var slide = slides[i];
      if (!slide) return;
      stage.scrollTo({
        left: slide.offsetLeft - stage.offsetLeft,
        behavior: reduced() ? 'auto' : 'smooth'
      });
    }

    function setActive(i) {
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });

    var raf = false;
    stage.addEventListener('scroll', function () {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () {
        raf = false;
        var i = clamp(Math.round(stage.scrollLeft / (stage.scrollWidth / slides.length)), 0, slides.length - 1);
        setActive(i);
      });
    }, { passive: true });

    // Touch devices get the fullscreen viewer, where pinch-to-zoom is the
    // browser's job rather than a JS approximation.
    if (!mqHover.matches) {
      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function () { openLightbox(slides, i); });
      });
    }
  }

  // Pointer-fine only. Touch uses the lightbox instead.
  function initZoom() {
    if (!mqHover.matches) return;
    $$('[data-cj-zoom]').forEach(function (frame) {
      if (frame.__bound) return;
      frame.__bound = true;
      var img = $('img', frame);
      if (!img) return;

      function origin(e) {
        var r = frame.getBoundingClientRect();
        var x = clamp((e.clientX - r.left) / r.width, 0, 1) * 100;
        var y = clamp((e.clientY - r.top) / r.height, 0, 1) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      }

      frame.style.cursor = 'zoom-in';
      frame.addEventListener('click', function (e) {
        var on = frame.classList.toggle('is-zoomed');
        if (on) origin(e); else img.style.transformOrigin = '';
      });
      frame.addEventListener('mousemove', function (e) {
        if (frame.classList.contains('is-zoomed')) origin(e);
      });
      frame.addEventListener('mouseleave', function () {
        frame.classList.remove('is-zoomed');
        img.style.transformOrigin = '';
      });
    });
  }

  /* ------------------------------------------------------- sticky buy bar */

  function initStickyBuy() {
    var bar = $('[data-cj-sticky-buy]');
    var anchor = $('#CjProductForm [data-cj-add]');
    if (!bar || !anchor) return;
    scrollTasks.push(function () {
      if (!mqPhone.matches) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        return;
      }
      var r = anchor.getBoundingClientRect();
      var show = r.bottom < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }

  /* ---------------------------------------------------- recommended products */

  function initRecommendations() {
    $$('[data-cj-recommendations]').forEach(function (host) {
      var url = host.getAttribute('data-url');
      if (!url || host.__loaded) return;
      host.__loaded = true;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cj-recommendations]');
          if (!fresh) return;
          host.innerHTML = fresh.innerHTML;
          initReveal(host);
          initSpecular(host);
          initWishlist(host);
          initWorn(host);
          initRails(host);
          bindAddForms(host);
        })
        .catch(function () { /* the page is fine without them */ });
    });
  }

  /* -------------------------------------------------------- variant picker */

  function initVariants(ctx) {
    $$('[data-cj-variants]', ctx || document).forEach(function (form) {
      if (form.__bound) return;
      form.__bound = true;
      var data = $('[data-cj-variant-data]', form);
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      var idInput = $('[data-cj-variant-id]', form);
      var submit = $('[data-cj-add]', form);
      var isMainForm = form.id === 'CjProductForm';

      function selected() {
        return $$('input[type="radio"]:checked, select', form)
          .filter(function (el) { return el.name && el.name.indexOf('cj-option') === 0; })
          .map(function (el) { return el.value; });
      }

      function update() {
        var chosen = selected();
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < chosen.length; j++) {
            if (variants[i].options[j] !== chosen[j]) { ok = false; break; }
          }
          if (ok) { match = variants[i]; break; }
        }
        if (!match) {
          if (submit) {
            submit.setAttribute('disabled', 'disabled');
            submit.textContent = str('unavailable', 'Unavailable');
          }
          return;
        }
        if (idInput) idInput.value = match.id;

        // The price appears in the info column and, on phones, in the sticky
        // bar. Scope to this form unless it is the page's main product form.
        var priceEls = isMainForm
          ? $$('[data-cj-variant-price]')
          : $$('[data-cj-variant-price]', form.closest('[data-cj-quick-content]') || form.parentNode);
        if (match.price_html) {
          priceEls.forEach(function (el) { el.innerHTML = match.price_html; });
        }

        if (submit) {
          if (match.available) {
            submit.removeAttribute('disabled');
            submit.textContent = str('addToCart', 'Add to cart');
          } else {
            submit.setAttribute('disabled', 'disabled');
            submit.textContent = str('soldOut', 'Sold out');
          }
        }

        if (isMainForm && window.history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      form.addEventListener('change', function (e) {
        if (e.target.name && e.target.name.indexOf('cj-option') === 0) update();
      });
    });
  }

  /* -------------------------------------------------------------- the cart */

  function updateCartCount(count) {
    $$('[data-cj-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function openDrawer() {
    var drawer = $('[data-cj-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockBody();
    overlay(true, closeDrawer);
    var close = $('[data-cj-drawer-close]', drawer);
    if (close) close.focus();
  }

  function closeDrawer() {
    var drawer = $('[data-cj-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockBody();
    overlay(false);
  }

  function refreshDrawer() {
    var drawer = $('[data-cj-drawer]');
    if (!drawer) return Promise.resolve();
    var id = drawer.getAttribute('data-section-id');
    return fetch(window.location.pathname + '?section_id=' + id, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cj-drawer-inner]');
        var target = $('[data-cj-drawer-inner]', drawer);
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        bindCartLineEvents(drawer);
      })
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch(CJ.routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if ($('[data-cj-cart-page]')) {
          window.location.reload();
          return cart;
        }
        return refreshDrawer().then(function () { return cart; });
      });
  }

  function bindCartLineEvents(ctx) {
    $$('[data-cj-line-remove]', ctx).forEach(function (btn) {
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(btn.getAttribute('data-cj-line-remove'), 0);
      });
    });
    $$('[data-cj-line-qty]', ctx).forEach(function (input) {
      if (input.__bound) return;
      input.__bound = true;
      input.addEventListener('change', function () {
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 1;
        changeLine(input.getAttribute('data-cj-line-qty'), qty);
      });
    });
    initQuantity(ctx);
  }

  // AJAX add-to-cart, shared by the product page, the quick view and the cards.
  function bindAddForms(ctx) {
    $$('form[action*="/cart/add"]', ctx || document).forEach(function (form) {
      if (form.__bound) return;
      form.__bound = true;
      form.addEventListener('submit', function (e) {
        if (CJ.cartType !== 'drawer') return; // let it post normally to /cart
        e.preventDefault();
        var btn = $('[data-cj-add]', form) || (e.submitter || null);
        var label = btn ? btn.textContent : '';
        var msg = $('[data-cj-add-error]', form);
        if (msg) { msg.hidden = true; msg.textContent = ''; }
        if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = str('adding', 'Adding…'); }

        fetch(CJ.routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message);
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            return refreshDrawer();
          })
          .then(function () { openDrawer(); })
          .catch(function (err) {
            if (msg) { msg.textContent = err.message || 'Could not add this item.'; msg.hidden = false; }
          })
          .finally(function () {
            if (btn) { btn.removeAttribute('disabled'); btn.textContent = label; }
          });
      });
    });
  }

  function initCart() {
    updateCartCountFromDom();

    $$('[data-cj-drawer-close]').forEach(function (b) {
      if (b.__bound) return;
      b.__bound = true;
      b.addEventListener('click', closeDrawer);
    });
    $$('[data-cj-cart-toggle]').forEach(function (b) {
      if (b.__bound) return;
      b.__bound = true;
      b.addEventListener('click', function (e) {
        if (CJ.cartType !== 'drawer') return; // let the link go to /cart
        e.preventDefault();
        openDrawer();
      });
    });

    document.addEventListener('keydown', function (e) {
      var drawer = $('[data-cj-drawer]');
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    bindCartLineEvents(document);
    bindAddForms(document);
  }

  function updateCartCountFromDom() {
    var el = $('[data-cj-cart-count]');
    if (!el) return;
    var n = parseInt(el.textContent, 10);
    if (!isNaN(n)) updateCartCount(n);
  }

  /* ---------------------------------------------------------- email capture */

  /* Every signup on the site posts the same Shopify customer form the footer
     has always used. Sending it over fetch keeps the visitor where they are —
     the endpoint, the hidden form_type and the contact[tags] value are
     identical to a normal submit, so entries land on the same customer list. */
  function bindSignupForms(ctx) {
    $$('[data-cj-signup]', ctx || document).forEach(function (wrap) {
      var form = wrap.querySelector('form');
      if (!form || form.__signup) return;
      form.__signup = true;

      var status = $('[data-cj-signup-status]', wrap);
      var btn = form.querySelector('button[type="submit"]');
      var input = form.querySelector('input[type="email"]');
      var scope = wrap.closest('.cj-pop') ? 'cj-pop' : 'cj-band';

      function say(message, kind) {
        if (!status) return;
        status.textContent = message || '';
        status.className = scope + '__status' + (kind ? ' ' + scope + '__status--' + kind : '');
        status.hidden = !message;
      }

      form.addEventListener('submit', function (e) {
        /* Let the browser own field validation and its own messaging. */
        if (!form.checkValidity()) return;
        e.preventDefault();

        var label = btn ? btn.textContent : '';
        if (btn) {
          btn.setAttribute('disabled', 'disabled');
          btn.textContent = str('signingUp', 'Joining…');
        }
        say('');

        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            /* Shopify bounces bot-suspect submissions to a challenge page that
               cannot be completed inside a popup. Hand over the real form. */
            if (res.url && res.url.indexOf('/challenge') !== -1) {
              form.__signup = false;
              form.submit();
              return null;
            }
            if (res.url && res.url.indexOf('customer_posted=true') !== -1) return true;
            return res.text().then(function (html) {
              return html.indexOf('customer_posted=true') !== -1;
            });
          })
          .then(function (ok) {
            if (ok === null) return;
            if (!ok) {
              say(str('signupError', 'That did not go through. Check the address and try again.'), 'error');
              return;
            }
            if (input) input.value = '';
            wrap.dispatchEvent(new CustomEvent('cj:signup', { bubbles: true }));
            /* The band confirms in place; the popup swaps panels instead. */
            var message = wrap.getAttribute('data-cj-signup-done');
            if (message) {
              var note = document.createElement('p');
              note.className = 'cj-form-status';
              note.textContent = message;
              wrap.innerHTML = '';
              wrap.appendChild(note);
            }
          })
          .catch(function () {
            say(str('signupError', 'That did not go through. Check the address and try again.'), 'error');
          })
          .finally(function () {
            if (btn) {
              btn.removeAttribute('disabled');
              btn.textContent = label;
            }
          });
      });
    });
  }

  function initSignupPopup() {
    var pop = $('[data-cj-popup]');
    if (!pop || pop.__bound) return;
    pop.__bound = true;

    var panel = $('[data-cj-popup-panel]', pop);
    var offer = $('[data-cj-popup-offer]', pop);
    var done = $('[data-cj-popup-done]', pop);
    var days = parseInt(pop.getAttribute('data-cj-popup-days'), 10);
    var delay = parseInt(pop.getAttribute('data-cj-popup-delay'), 10);
    var wantsExit = pop.getAttribute('data-cj-popup-exit') === 'true';
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var KEY = 'cj-signup-popup';
    var lastFocus = null;
    var timer = null;
    var isOpen = false;

    if (isNaN(days)) days = 30;
    if (isNaN(delay)) delay = 5;

    /* Frequency cap. localStorage holds the date it may return; sessionStorage
       makes a dismissal final for the rest of this visit regardless. */
    function suppressed() {
      try {
        if (window.sessionStorage.getItem(KEY) === 'closed') return true;
        var until = parseInt(window.localStorage.getItem(KEY), 10);
        return !isNaN(until) && until > Date.now();
      } catch (e) {
        return false;
      }
    }
    function suppress() {
      if (designMode) return;
      try {
        window.sessionStorage.setItem(KEY, 'closed');
        window.localStorage.setItem(KEY, String(Date.now() + days * 86400000));
      } catch (e) {}
    }

    function focusables() {
      return $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', panel)
        .filter(function (el) { return el.offsetParent !== null; });
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      window.clearTimeout(timer);
      lastFocus = document.activeElement;
      pop.hidden = false;
      lockBody();
      overlay(true, close);
      requestAnimationFrame(function () {
        pop.classList.add('is-open');
        pop.setAttribute('aria-hidden', 'false');
        /* Focus the close button, not the field — focusing an input here would
           throw up the keyboard on mobile the moment the sheet appears. */
        var target = $('[data-cj-popup-close]', pop);
        if (target) target.focus({ preventScroll: true });
      });
      document.addEventListener('keydown', onKeydown, true);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      unlockBody();
      overlay(false);
      document.removeEventListener('keydown', onKeydown, true);
      window.setTimeout(function () {
        if (!pop.classList.contains('is-open')) pop.hidden = true;
      }, 420);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      suppress();
    }

    $$('[data-cj-popup-close]', pop).forEach(function (b) {
      b.addEventListener('click', close);
    });

    pop.addEventListener('cj:signup', function () {
      if (offer) offer.hidden = true;
      if (done) done.hidden = false;
      suppress();
      var next = $('[data-cj-popup-close]', done || pop);
      if (next) next.focus({ preventScroll: true });
    });

    /* In the customizer, tie it to selecting the section rather than a timer —
       otherwise it keeps interrupting whoever is editing the rest of the page. */
    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains(pop)) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.contains(pop)) close();
      });
      return;
    }

    if (suppressed()) return;

    timer = window.setTimeout(open, Math.max(0, delay) * 1000);

    if (wantsExit && mqHover.matches) {
      document.addEventListener('mouseout', function onOut(e) {
        /* A null relatedTarget above the viewport means the pointer left the
           window upward — heading for the tab bar or the close button. */
        if (isOpen || e.clientY > 0 || e.relatedTarget) return;
        document.removeEventListener('mouseout', onOut);
        open();
      });
    }
  }

  /* ----------------------------------------------------- theme editor hooks */

  function initAll() {
    initHeader();
    initMenu();
    initReveal();
    initSpecular();
    if (motionOn() && CJ.shine !== false) scrollTasks.push(specularTask);
    initFloat();
    initTilt();
    initWishlist();
    initWorn();
    initRails();
    initQuickView();
    initLightbox();
    initFilters();
    initAccordions();
    initQuantity(document);
    initProductGallery();
    initZoom();
    initStickyBuy();
    initRecommendations();
    initVariants();
    initCart();
    bindSignupForms(document);
    initSignupPopup();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    scrollTasks.length = 0;
    initAll();
  });
  document.addEventListener('shopify:section:unload', function () {
    scrollTasks.length = 0;
  });
})();
